<p-dialog
  header="Nueva liga de registro"
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving()"
  appendTo="body"
  [style]="{ width: 'min(34rem, calc(100vw - 2rem))' }">
  @if (issued(); as mandate) {
    <div class="flex flex-col gap-3 pt-1">
      <p class="text-sm text-slate-600 m-0">
        Enviamos la liga a <span class="font-medium text-slate-900">{{ mandate.customerEmail }}</span>. La liga anterior ya no funciona.
      </p>
      @if (mandate.enrollmentExpiresAt) {
        <p class="text-xs text-slate-500 m-0">Vence el {{ mandate.enrollmentExpiresAt | date:'dd/MM/yyyy HH:mm' }}.</p>
      }
    </div>
  } @else {
    <div class="flex flex-col gap-3 pt-1">
      <p class="text-sm text-slate-600 m-0">Se emite una liga nueva para que el cliente registre su tarjeta; la anterior deja de funcionar.</p>
      <p class="text-xs text-slate-500 m-0">
        @if (mandate()?.initialCharge; as initialCharge) {
          Al registrar su tarjeta se hará el primer cobro de {{ initialCharge.amount | currency:'MXN':'symbol-narrow' }}.
        } @else {
          Al registrar su tarjeta se hará un cargo de validación que se cancela de inmediato.
        }
      </p>
      @if (error()) {
        <p class="text-sm text-red-600 m-0">{{ error() }}</p>
      }
    </div>
  }
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button [label]="issued() ? 'Listo' : 'Cerrar'" severity="secondary" [text]="!issued()" type="button" [disabled]="saving()" (onClick)="close()" />
      @if (!issued()) {
        <p-button label="Emitir y enviar liga" icon="pi pi-send" type="button" [loading]="saving()" (onClick)="issue()" />
      }
    </div>
  </ng-template>
</p-dialog>
